import { Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";
import { retrieveSchool, schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import { retrieveDpto, dptoSlice, selectDpto } from "../../../redux/dpto/dptoSlice";
import { useAppDispatch } from "../../../app/hooks";
import { LoadState } from "../../../redux/common";
import { isTokenReady } from "../../../features/user/UserAvatar";
import { useEffect } from "react";

interface DptoPageTitleProps {
    schoolId: string;
    dptoId: string;
}

const DptoPageTitle = ({ schoolId, dptoId }: DptoPageTitleProps) => {
    const user = useSelector(selectUser);
    const school = useSelector(selectSchool);
    const dpto = useSelector(selectDpto);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (school.selected && school.selected.id != schoolId) {
            dispatch(schoolSlice.actions.clean());
        }
        if (school.state.state == LoadState.NotStarted && isTokenReady(user)) {
            dispatch(retrieveSchool({ schoolId: schoolId }));
        }
    }, [schoolId, school, user]);

    useEffect(() => {
        if (dpto.selected && dpto.selected.id != dptoId) {
            dispatch(dptoSlice.actions.clean());
        }
        if (dpto.state.state == LoadState.NotStarted && isTokenReady(user)) {
            dispatch(retrieveDpto({ dptoId: dptoId }));
        }
    }, [dptoId, dpto, user]);


    return (school.selected?.name && dpto.selected?.name) ?
        <Stack sx={{ flexGrow: 1 }}>
            <Typography variant="caption" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
                {school.selected.name}
            </Typography>
            <Typography variant="subtitle1" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
                {dpto.selected.name}
            </Typography>
        </Stack>
        : <Typography variant="h6" component="div" overflow="hidden" whiteSpace="nowrap" sx={{ flexGrow: 1 }}>
            Departamento
        </Typography>;
};

export default DptoPageTitle;